export const viewports = {
  mobile: 720,
  laptop: 1256,
};

export const device = {
  mobile: `(max-width: ${viewports.mobile}px)`,
  laptop: `(max-width: ${viewports.laptop}px)`,
};
